import RegistrationField, { RegistrationFields, RegistrationFieldClass } from './RegistrationField'
import Date from './field/Date'
import Dropdownn from './field/Dropdown'
import Email from './field/Email'
import Phone from './field/Phone'
import School from './field/School'
import TextBox from './field/TextBox'
import VisitorType from './field/VisitorType'
import ZipCode from './field/ZipCode'
import GPA from './field/GPA'

function RegistrationForm(opts) {
    this._registration = opts.registration
    this._fields = {}
    this.id = opts.formID
    this.title = opts.definition.title
    this.loc_name = opts.loc_name ? opts.loc_name : ''
    this.formTitle = opts.isRegInitByCTA ? 'Registration' : 'Get Started!'
    this.subtitle = opts.definition.subtitle
    this.imageUrl = opts.definition.image
    this.submitText = opts.definition.submitText
    this.onComplete = opts.onComplete
    this.onSubmit = opts.onSubmit
    this.emailEnabled = opts.emailEnabled
    this.source = opts.source
    this.policyURLs = opts.definition.policyURLs

    //currently long form on desktop is the submission modal
    if (!this._registration.mobile && this.id === 'long') {
        this.formTitle = 'Thanks for your submission!'
    }

    if (this.source == 'web') {
        if (opts.isRegInitByCTA) {
            this.title = 'Almost Done!'
            this.subtitle = 'Tell us more about yourself to receive information and customize your experience!'
        } else {
            this.title = ''
            this.subtitle = 'Tell us more about yourself to get started.'
        }
    }

    this.$html = $(this._buildHtml())
    this.$fields = this.$html.find('.form-fields')
    this.$submitBtn = this.$html.find('.form-submit-btn')

    this.$requiredTitle = this.$html.find('.form-required-title')
    this.$subtitle = this.$html.find('.form-subtitle')

    var fields = opts.definition.fields

    this._createFields(fields)

    this._applyBindings()
    this.$html
        .find(':tabbable')
        .first()
        .focus()
}
RegistrationForm.prototype = {
    getFields: function() {
        return this._fields
    },

    scrollToFirstError: function() {
        if (this._registration.isMaterialUI()) {
            this._scrollToElement(this.$fields.find('.error').first())
        } else {
            var selector = this._registration.mobile ? '.mobile-errors' : '.error-wrap-inner.show:eq(0)'
            this._scrollToElement(this.$fields.find(selector))
        }
    },

    updateFormTitleText: function(formid) {
        var selectShortForm = ".registration-form[form-id='" + (formid || 'short') + "']"
        $(selectShortForm + ' .branding-title').text(this.title)
        $(selectShortForm + ' .branding-subtitle').text(this.subtitle)
        $(selectShortForm + ' .form-title').text(this.formTitle)
        $(selectShortForm + ' .form-title').attr('aria-live', 'assertive')
    },

    focusMain: function(formid) {
        var selectShortForm = ".registration-form[form-id='" + (formid || 'short') + "']"
        $(selectShortForm + ' .form-main')
            .first()
            .focus()
    },

    policyHTML: function() {
        if (this.policyURLs) {
            var tos = `<a href="${this.policyURLs.tos.url}" class="reg-newtab-link" alt="Registration Terms-of-Use" target="_blank"> ${this.policyURLs.tos.text}</a>`
            var ppolicy = `<a href="${this.policyURLs.pp.url}" class="reg-newtab-link" alt="Registration Privacy-Policy" target="_blank"> ${this.policyURLs.pp.text}</a>`
            var externalPolicy = this.policyURLs.external
                ? `<a href="${this.policyURLs.external.url}" class="reg-newtab-link" alt="Registration External-Policy" target="_blank"> ${this.policyURLs.external.text}</a>`
                : ''
            var conjunction = this.policyURLs.external && this.policyURLs.external.url ? ', ' : 'and '
            var cssClass = this.policyURLs.external && this.policyURLs.external.url ? 'small' : ''
            var andClient =
                this.policyURLs.external && this.policyURLs.external.url
                    ? `and ${this.loc_name} ${externalPolicy}.`
                    : '.'
            var html = `
                <div class="policy-agreement ${cssClass}">
                By clicking the button above you are agreeing to the YouVisit ${tos} ${conjunction} ${ppolicy} ${andClient}
                </div>`

            return html
        }
        return ''
    },

    _buildHtml: function() {
        var isMobile = this._registration.mobile // is this mobile registration?
        var isTablet = this._registration.tablet

        var html =
            '' +
            '<form class="registration-form ' +
            this._registration.source +
            '" form-id="' +
            this.id +
            '">' +
            '<table><tr>' +
            (isMobile && !isTablet
                ? ''
                : '' +
                  '<td class="form-branding">' +
                  '<div class="branding-text-wrapper" data-ada-first tabindex="0">' +
                  '<div class="branding-title">' +
                  this.title +
                  '</div>' +
                  '<div class="branding-subtitle">' +
                  this.subtitle +
                  '</div>' +
                  '</div>' +
                  '<img src="' +
                  this.imageUrl +
                  '" alt="Contact Us! ' +
                  this.loc_name +
                  ' Logo. Register now to stay in touch with ' +
                  this.loc_name +
                  '." />' +
                  '</td>') +
            '<td class="form-border-line"></td>' +
            '<td class="form-main">' +
            '<div class="form-title" aria-live="assertive">' +
            this.formTitle +
            '</div>' +
            '<div class="form-subtitle">' +
            this.subtitle +
            '</div>' +
            '<div class="form-required-title">* Required Fields</div>' +
            '<div class="form-fields">' +
            (isMobile ? '<div class="mobile-errors"></div>' : '') +
            '</div>' +
            '<button class="form-submit-btn" type="submit">' +
            this.submitText +
            '</button>' +
            '<div class="policy-container">' +
            this.policyHTML() +
            '</div>' +
            '</td>' +
            '</tr></table>' +
            '</form>'
        return html
    },

    _createFields: function(fieldDefs) {
        var self = this

        var $fields = this.$html.find('.form-fields')

        var $row
        var $error

        for (var f = 0, ff = fieldDefs.length; f < ff; ++f) {
            var def = fieldDefs[f]

            // add field to row
            var rowOrder = Math.floor(def.sort_order)
            var isRowStart = f === 0 || rowOrder !== Math.floor(fieldDefs[f - 1].sort_order)
            var isRowEnd = f === ff - 1 || rowOrder !== Math.floor(fieldDefs[f + 1].sort_order)

            // create row
            if (isRowStart) {
                $row = $('<div class="form-row"></div>')
                $error = $('<div class="error-wrap-outer"><div class="error-wrap-inner"></div></div>')

                if (this._registration.mobile) {
                    $fields.find('>.mobile-errors').append($error)
                } else {
                    $fields.append($error)
                }
            }

            // add row to form
            if (isRowEnd) {
                $fields.append($row)
            }

            var fieldClass

            var opts = {
                registration: this._registration,
                form: this,
                definition: def,
                $error: $error.find('.error-wrap-inner'),
            }
            // hardcode for now
            if (def.fieldid === RegistrationFields.VISITOR_TYPE) {
                fieldClass = RegistrationFieldClass.VISITOR_TYPE

                // Special condition for when the list is empty, then  skip this field
                if (def.list.length === 0) {
                    continue
                }
            } else if (def.fieldid === RegistrationFields.SCHOOL) {
                fieldClass = RegistrationFieldClass.SCHOOL
            } else if (def.fieldid === RegistrationFields.US_POSTAL) {
                fieldClass = RegistrationFieldClass.ZIP_CODE
            } else if (def.fieldid === RegistrationFields.GPA) {
                fieldClass = RegistrationFieldClass.GPA
            } else if (def.fieldid === RegistrationFields.COUNTRY) {
                fieldClass = RegistrationFieldClass.DROPDOWN

                opts.onValueChange = function(field, oldV, newV) {
                    self._scrollToElement(field.$html)
                }
            } else if (def.input_type === 'date') {
                fieldClass = RegistrationFieldClass.DATE
            } else if (def.input_type === 'email') {
                fieldClass = RegistrationFieldClass.EMAIL
            } else if (def.input_type === 'phone') {
                fieldClass = RegistrationFieldClass.PHONE
            } else if (def.input_type === 'list' && def.list.length) {
                fieldClass = RegistrationFieldClass.DROPDOWN
            } else {
                fieldClass = RegistrationFieldClass.TEXTBOX
            }

            // Create the specific field from the YouVisit.Registration.Field namespace
            var field

            switch (fieldClass) {
                case RegistrationFieldClass.VISITOR_TYPE:
                    field = new VisitorType(opts)
                    break
                case RegistrationFieldClass.DATE:
                    field = new Date(opts)
                    break
                case RegistrationFieldClass.DROPDOWN:
                    field = new Dropdownn(opts)
                    break
                case RegistrationFieldClass.EMAIL:
                    field = new Email(opts)
                    break
                case RegistrationFieldClass.PHONE:
                    field = new Phone(opts)
                    break
                case RegistrationFieldClass.SCHOOL:
                    field = new School(opts)
                    break
                case RegistrationFieldClass.GPA:
                    field = new GPA(opts)
                    break
                case RegistrationFieldClass.TEXTBOX:
                    field = new TextBox(opts)
                    break
                case RegistrationFieldClass.ZIP_CODE:
                    field = new ZipCode(opts)
                    break
                default:
                    field = new RegistrationField(opts)
            }

            field.applyBindings()
            $row.append(field.$html)

            // add field
            this._fields[def.fieldid] = field
        }
    },

    _applyBindings: function() {
        var self = this

        this.$html.on('submit', function(evt) {
            evt.preventDefault()

            //function for when we successfully submit form
            //if email is enabled, we will email the user
            //after successfully submitting the form
            if (self.id === 'long') {
                //long form is the success modal after submitting
                //isComplete is true when hitting done button on success modal
                self.onComplete({
                    completeText: '',
                    emailEnabled: self.emailEnabled,
                })
            } else {
                self.$submitBtn.text('Sending...')
                self.$submitBtn.attr('alt', 'submitting registration.')

                self._registration.submitForm(self, function() {
                    self.$submitBtn.text(self.submitText)
                    self.$submitBtn.attr('alt', self.submitText)

                    self.onSubmit({
                        fields: self._fields,
                    })
                })
            }
        })
    },

    _scrollToElement: function($element) {
        if ($element.length) {
            var $container
            if (this._registration.isMaterialUI()) {
                $container = this.$fields
            } else {
                $container = this._registration.mobile ? this._registration.$dialog : this.$fields
            }
            if ($element.offset() && $container.offset()) {
                $container.animate(
                    {
                        scrollTop: $element.offset().top - $container.offset().top + $container.scrollTop(),
                    },
                    400
                )
            }

            /* Force user to take action by focusing on first issue */
            var $focusableElmenet = $element.find('input')
            /* No input? handle special case for grid selector  */
            if (!$focusableElmenet.length) $focusableElmenet = $element.find('.visible_area').first()
            /* No visibale_area? find the first div? */
            if (!$focusableElmenet.length) $focusableElmenet = $element.find('div').first()
            /* now focus */
            if ($focusableElmenet.length) $focusableElmenet.focus().click()
        }
    },
}

export default RegistrationForm
